import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import VueResource from 'vue-resource';
import VueJwtDecode from 'vue-jwt-decode';
import swal from 'sweetalert';

Vue.config.productionTip = false;

Vue.use(VueJwtDecode);
Vue.use(VueResource);

Vue.http.options.root = 'https://psicometricosfime.com/api/public/pri';

localStorage.apikeySiepsPsicometricosFimeUanl=JSON.stringify("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzaWVwc191YW5sX3RfbWVkaWNhIiwiZGF0YSI6eyJpZHNvbGljaXR1ZCI6IjEiLCJpZGFsdW1ubyI6IjEifSwiaWF0IjoxNzg0NjU2Njg1LCJleHAiOjIxMDAyNzU4ODV9.Xv0TEN3BdYpxTUEaiveWDksmbkPE1qfP16_nqMJwwLE");

Vue.http.interceptors.push((request, next) => {
  if (!localStorage.getItem('apikeySiepsPsicometricosFimeUanl') || localStorage.getItem('apikeySiepsPsicometricosFimeUanl')=='undefined' || localStorage.getItem('apikeySiepsPsicometricosFimeUanl')==undefined) {
    localStorage.apikeySiepsPsicometricosFimeUanl=JSON.stringify("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzaWVwc191YW5sX3RfbWVkaWNhIiwiZGF0YSI6eyJpZHNvbGljaXR1ZCI6IjEiLCJpZGFsdW1ubyI6IjEifSwiaWF0IjoxNzg0NjU2Njg1LCJleHAiOjIxMDAyNzU4ODV9.Xv0TEN3BdYpxTUEaiveWDksmbkPE1qfP16_nqMJwwLE");
  }
  request.headers.set('Authorization', 'Bearer '+JSON.parse(localStorage.apikeySiepsPsicometricosFimeUanl))
  request.headers.set('Accept', 'application/json')
  next(res => {
  })
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js